export default __webpack_public_path__ + "static/media/xpensityV2-tablet-main.93d64906.webp";